module.exports = __webpack_public_path__ + "static/img/purepay-logo.f5292231.png";